import { UI_AdaptableList } from 'ui/components/3-organisms/AdaptableList/AdaptableList';

export const AdaptableListFeature: React.FC<Content.AdaptableList> = ({ content }) => {
	const { items } = content?.properties ?? {};
	return (
		<UI_AdaptableList
			title={content?.properties?.heading}
			description={content?.properties?.description}
			adaptableListitem={items?.map(
				({
					content: {
						properties: { headline, text, image, link, firstTag, secondTag, video },
					},
				}) => ({
					headline,
					text,
					image: { ...image, altText: image?.properties?.altText },
					link,
					tags: { first: firstTag, second: secondTag },
					video: video ? { ...video, mediaURL: video.url, posterURL: video.poster } : undefined,
				}),
			)}
			buttonText={content?.properties?.buttonText}
			bgColor={content?.properties?.color}
		/>
	);
};
